<template>
  <div class="app-container comment-list">
    <div class="comment-list-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="comment-list-filter-label">内容</label>
            <el-input class="comment-list-filter-value" v-model="search.content" clearable size="small"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="comment-list-filter-label">发布者</label>
            <el-input class="comment-list-filter-value" v-model="search.commentByName" clearable size="small"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="comment-list-filter-label">帖子标题</label>
            <el-input class="comment-list-filter-value" v-model="search.postTitle" clearable size="small"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="comment-list-filter-label">状态</label>
            <el-select class="comment-list-filter-value" placeholder="" v-model="search.status" clearable size="small">
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="9">
          <div class="grid-content bg-purple">
            <label class="comment-list-filter-label">发布时间</label>
            <el-date-picker
               class="comment-list-filter-date"
              v-model="search.searchTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              size="small">
            </el-date-picker>
          </div>
        </el-col>
        <div>
          <el-button class="comment-list-filter-search" size="small" @click="searchReset">清空</el-button>
          <el-button class="comment-list-filter-reset" type="primary" size="small" @click="searchChange">搜索</el-button>
        </div>
      </el-row>
    </div>

    <basic-container class = "comment-list-container">
      <avue-crud ref="crud"
                 :option="commentTableOption"
                 :data="tableData"
                 :page="page"
                 :table-loading="tableLoading"
                 :before-open="handleOpenBefore"
                 @current-change="handleCurrentChange"
                 @refresh-change="handleRefreshChange"
                 @size-change="handleSizeChange"
                 @sort-change="sortChange">

        <template slot="content"
                  slot-scope="scope">
          <span>{{scope.row.content}}</span>
        </template>

        <template slot="commentByName"
                  slot-scope="scope">
          <a href="javascript:void(0);" @click="toMemberDetail(scope.row.commentBy.id);"
              class="comment-list-container-button">
            {{scope.row.commentByName}}</a>
        </template>

        <template slot="postTitle"
                  slot-scope="scope">
          <a href="javascript:void(0);" @click="toPostDetail(scope.row.postId);"
              class="comment-list-container-button">
            {{scope.row.postTitle}}</a>
        </template>

        <template slot="menu"
                  slot-scope="scope" width=100>
          <el-button size="mini"
                type="text"
                icon="el-icon-view"
                v-if="permissions.comment_view"
                @click="handleView(scope.row,scope.index)">查看
          </el-button>
          <el-button size="mini"
                type="text"
                icon="el-icon-upload2"
                v-if="permissions.comment_update_up && scope.row.isBanned && scope.row.isActive"
                @click="handleUp(scope.row,scope.index)">上架
          </el-button>
          <el-button size="mini"
                type="text"
                icon="el-icon-download"
                v-if="permissions.comment_update_down && !scope.row.isBanned && scope.row.isActive"
                @click="handleDown(scope.row,scope.index)">下架
          </el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
  import {fetchCommentList, putComment} from '@/api/post/comment'
  import {commentTableOption} from '@/const/crud/post/comment'
  import {mapGetters} from "vuex";
  import {constants} from 'fs';
  import {connect} from 'tls';

  export default {
    name: "table_comment",
    data() {
      return {
        // 搜索功能
        statusOptions: [
          {
            label: '已上架',
            value: 0
          },
          {
            label: '已下架',
            value: 1
          },
          {
            label: '已删除',
            value: 2
          }
        ],
        search: {
          current: 1,
          size: 20,
          content: "",
          commentByName: "",
          postTitle: "",
          status: "",
          searchTime: [],
        },

        sort: {
          sortField: null,
          sortPolicy: '',
        },

        // 列表页面
        tableData:[],
        page: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 20, // 每页显示多少条,
        },
        tableLoading: false,
        commentTableOption: commentTableOption,
      };
    },
    created() {
      this.queryComments()
    },
    computed: {
      ...mapGetters(['permissions']),
      startTime: function () {
        if (this.search.searchTime && this.search.searchTime.length > 0) {
          return this.search.searchTime[0]
        } else {
          return null
        }
      },
      endTime: function () {
        if (this.search.searchTime && this.search.searchTime.length > 1) {
          return this.search.searchTime[1]
        } else {
          return null
        }
      }
    },
    methods: {
      formatData(records) {
        // 评论列表格式化
        let _this = this
        if (records && records.length > 0) {
          records.forEach(function(record, index) {
            record.postTitle = record.postTitle || '--';
            if (record.commentBy) {
              record.commentByName = record.commentBy.name
            }
            if (record.isActive == 0) {
              record.status = '已删除'
            }
            if (record.isActive == 1 && record.isBanned == 0) {
              record.status = '已上架'
            }
            if (record.isActive == 1 && record.isBanned == 1) {
              record.status = '已下架'
            }
          })
        }
        return records
      },
      getParameter(param){
        // 提取url参数值
        let url = location.href
        let reg = new RegExp("(^|&)" + param + "=([^&]*)(&|$)")
        let r = url.substr(url.indexOf("\?") + 1).match(reg)
        if (r != null) return unescape(r[2])
        else return null
      },
      getList() {
        // 获取评论列表
        let params = {
          current: this.search.current,
          size: this.search.size,
          sortField: this.sort.sortField,
          sortPolicy: this.sort.sortPolicy
        }

        // 增加搜索功能
        if (this.search.content != "" && this.search.content.trim() != "")
          params.content = this.search.content
        if (this.search.commentByName != "" && this.search.commentByName.trim() != "")
          params.commentByName = this.search.commentByName
        if (this.search.postTitle != "" && this.search.postTitle.trim() != "")
          params.postTitle = this.search.postTitle
        if (this.search.status !== null && this.search.status !== "") {
          if (this.search.status === 0 || this.search.status === 1) {
            // 三种状态: 已上架(0)，已下架(1)，已删除(2)
            params.isBanned = this.search.status
            params.isActive = 1
          } else if (this.search.status === 2) {
            params.isActive = 0
          }
        }

        if (this.startTime && this.endTime) {
          params.commentStartTime = this.startTime
          let t = new Date(this.endTime)
          t.setDate(t.getDate() + 1)
          params.commentEndTime = t.getFullYear() + '-' + (t.getMonth() + 1) + '-' + t.getDate()
        } else {
          params.commentStartTime = null
          params.commentEndTime = null
        }

        // 获取url对应postId参数值做筛选
        let postIdParam = this.getParameter("postId")
        if (postIdParam != null && postIdParam != "")
          params.postId = postIdParam
        // 获取url对应memberId参数值做筛选
        let memberIdParam = this.getParameter("memberId")
        if (memberIdParam != null && memberIdParam != "")
          params.commentBy = memberIdParam

        if (this.sort.sortField) {
          params[this.sort.sortPolicy] = this.sort.sortField;
        }

        this.tableLoading = true
        fetchCommentList(params).then(response => {
          this.tableData = this.formatData(response.data.data.records)
          this.page.total = response.data.data.total
          this.tableLoading = false
        })
      },
      initPage() {
        this.page.currentPage = 1
        this.page.pageSize = this.search.size
        this.search.current = 1
        this.search.sortField = ""
        this.search.sortPolicy = ""
      },
      searchChange() {
        this.initPage()
        this.getList()
      },
      searchReset() {
        this.search.content = ""
        this.search.commentByName = ""
        this.search.postTitle = ""
        this.search.status = null
        this.search.searchTime = []
        this.searchChange()
      },
      toMemberDetail(id) {
        // 评论详情里点击发布者姓名，链接转到该发布者的会员详情
        this.$router.push({
          path: `/upms/member/detail/${id}`,
        })
      },
      toPostDetail(id) {
        this.$router.push({
          path: `/post/posts/detail/${id}`
        })
      },
      handleView(row, index) {
        this.$router.push({
          path: `/post/comment/${row.id}`,
        });
      },
      handleCurrentChange(val) {
        this.page.currentPage = val
        this.search.current = val
        this.getList()
      },
      handleRefreshChange() {
        this.getList()
      },
      handleSizeChange(val) {
        this.page.pageSize = val
        this.search.size = val
        this.getList()
      },
      getNodeData(data,done) {
        done()
      },
      handleOpenBefore(show, type) {
        show();
      },
      getPostCommentDTO(row, inputIsBanned){
        let postCommentDTO= {
          id: row.id,
          isBanned: inputIsBanned,
        }
        return postCommentDTO
      },
      handleUp(row, index) {
        // 上架功能
        let postCommentDTO = this.getPostCommentDTO(row, 0)
        let _this = this
        this.$confirm('是否确认上架该ID为"' + row.id + '"'+ '的评论?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          return putComment(postCommentDTO);
        }).then(() => {
          this.getList()
          _this.$message({
            showClose: true,
            message: '上架成功',
            type: 'success'
          })
        }).catch(function () {
        })
      },
      handleDown(row, index) {
        // 下架功能
        let postCommentDTO = this.getPostCommentDTO(row, 1)
        let _this = this
        this.$prompt('下架原因', '下架', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern:/^.*[^\s]+.*$/,
          inputErrorMessage: '不能为空'
        }).then(banCommentValue => {
          postCommentDTO.banComment = banCommentValue.value;
          return putComment(postCommentDTO)
        }).then(response => {
          this.getList()
          _this.$message({
            showClose: true,
            type: 'success',
            message: '下架成功'
          })
        }).catch(function () {
        })
      },
      sortChange(val) {
        if (val.prop === 'likeCount') {
          this.sort.sortField = 'like_count';
        } else if (val.prop === 'commentTime') {
          this.sort.sortField = 'comment_time';
        }
        if (val.order === 'ascending') {
          this.sort.sortPolicy = 'asc';
        } else if (val.order === 'descending') {
          this.sort.sortPolicy = 'desc';
        } else {
          this.sort.sortField = null;
          this.sort.sortPolicy = '';
        }
        this.getList()
      },
      queryComments() {
        if (this.$route.query.date !== undefined) {
          this.search.searchTime.push(this.$route.query.date, this.$route.query.date)
        }
        this.getList()
      }
    }
  };

</script>

<style lang="scss" scoped>

.comment-list {
  &-filter {
    margin: 0px 10px;
    background-color: #fff;
    padding-top: 20px;
    padding-left: 22px;

    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 10px;
    }
    &-value {
      width: calc(100% - 90px) !important;
    }
    &-date {
      width: calc(100% - 150px) !important;
    }
    &-search {
      float: right;
      margin-right: 30px;
    }
    &-reset {
      float: right;
      margin-right: 10px;
    }
  }

  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
    }
  }
}
</style>
